import router from "@/router";
import ProjectIcon from "@core/components/project-icon/ProjectIcon.vue";

export default [
	{
		title: "Analysis",
		route: "graph-analysis-list-flock",
		icon: "BarChartIcon",
		roles: ["owner", "admin"],
	},
	{
		title: "Master Entry",
		icon: "FileIcon",
		roles: ["owner", "admin"],
		moduleSlug: "master_entry",
		children: [
			{
				title: "Master Data",
				route: "apps-master-data",
			},
			{
				title: "Schedule",
				route: "apps-master-schedule",
			},
			// {
			// 	title: "Breed Standard",
			// 	route: "apps-master-breed-standard",
			// },
		],
	},
	{
		title: "Users",
		icon: "UserIcon",
		roles: ["owner", "admin", "manager"],
		children: [
			{
				title: "Admin",
				route: "apps-admin-list",
				roles: ["owner"],
			},
			{
				title: "Manager",
				route: "apps-manager-list",
				roles: ["owner", "admin"],
			},
			{
				title: "AssistantManager",
				route: "apps-assistant-list",
				roles: ["owner", "admin", "manager"],
			},
			{
				title: "Supervisor",
				route: "apps-supervisor-list",
				roles: ["owner", "admin", "manager"],
			},
			{
				title: "Doctor",
				route: "apps-doctor-list",
				roles: ["owner"],
			},
		],
	},
	// {
	// 	title: "Purchase",
	// 	route: "apps-purchase",
	// 	icon: "CalendarIcon",
	// 	roles: ["admin", "owner"],
	// },
	// {
	// 	title: "Inventory",
	// 	route: "apps-inventory",
	// 	icon: "InfoIcon",
	// 	roles: ["admin", "owner"],
	// },
	// {
	// 	title: "Expense Entry",
	// 	route: "apps-expense-list",
	// 	icon: "UsersIcon",
	// 	roles: ["admin", "owner"],
	// },
	// {
	// 	title: "Current Batch",
	// 	route: "",
	// 	icon: "CalendarIcon",
	// },
	// {
	// 	title: "Action list",
	// 	route: "apps-action-list",
	// 	icon: "CalendarIcon",
	// 	roles: ["admin", "owner"],
	// },
	// {
	// 	title: "Alarm",
	// 	route: "apps-alarm",
	// 	icon: "BellIcon",
	// 	roles: ["admin", "owner"],
	// },
	{
		title: "Farm",
		route: "apps-farm-list",
		icon: "UsersIcon",
		roles: ["owner", "admin"],
		moduleSlug: "farm",
	},
	{
		title: "Purchase",
		route: "apps-company-purchase",
		icon: "CalendarIcon",
		roles: ["admin", "owner"],
		moduleSlug: "company_purchase",
	},
	{
		title: "Inventory",
		route: "apps-company-inventory",
		icon: "InfoIcon",
		roles: ["admin", "owner"],
		moduleSlug: "company_inventory",
	},
	{
		title: "Supply to Farm",
		route: "apps-supply-farm-list",
		icon: "FileIcon",
		roles: ["admin", "owner"],
		moduleSlug: "supply_to_farm",
	},
	// Economic Report
	{
		title: "Economic Report",
		route: "farm-apps-economic-report",
		icon: "CalendarIcon",
		roles: ["owner"],
	},

	{
		title: "Feed Formula",
		route: "farm-apps-feed-formula",
		icon: "CalendarIcon",
		roles: ["owner", "admin"],
	},
	// roles
	{
		title: "Roles",
		route: "company-apps-roles",
		icon: "UsersIcon",
		roles: ["owner"],
	},
	// permission
	{
		title: "Permission",
		route: "company-apps-permission",
		icon: "UsersIcon",
		roles: ["owner"],
	},

	// ── Hygiene Testing ──────────────────────────────────
	{
		header: "Hygiene Testing",
	},
	{
		title: "Hygicult MMF",
		route: "owner-hygicult",
		icon: "ActivityIcon",
		roles: ["owner", "admin", "manager"],
		moduleSlug: "hygicult_mmf",
	},

	// ── Marketplace ──────────────────────────────────────
	{
		header: "Marketplace",
	},
	{
		title: "Bird Sale",
		route: "apps-market-bird-sale",
		icon: "FeatherIcon",
		roles: ["owner", "admin"],
		moduleSlug: "bird_sale",
	},
	// "My Listings" (legacy open-listing + bidding console — its page is also
	// titled "Bird Sales") hidden to avoid duplicating "Bird Sale". Route/view
	// kept intact; restore this block to bring back the bidding-based listing flow.
	// {
	// 	title: "My Listings",
	// 	route: "apps-market-listings",
	// 	icon: "TagIcon",
	// 	roles: ["owner", "admin"],
	// },
	{
		title: "Bookings",
		route: "apps-market-bookings",
		icon: "ShoppingCartIcon",
		roles: ["owner", "admin"],
		moduleSlug: "bookings",
	},


	// ── New Features ──────────────────────────────────────
	{
		header: "Intelligence",
	},
	{
		title: "Market Prices",
		route: "market-prices",
		icon: "TrendingUpIcon",
		roles: ["owner", "admin"],
		moduleSlug: "market_prices",
	},
	{
		title: "Disease Alerts",
		route: "disease-alerts",
		icon: "AlertTriangleIcon",
		roles: ["owner", "admin"],
		moduleSlug: "disease_alerts",
	},
	{
		title: "Health Scores",
		route: "health-scores",
		icon: "ActivityIcon",
		roles: ["owner", "admin"],
		moduleSlug: "health_scores",
	},
	{
		title: "Benchmarking",
		route: "benchmarking",
		icon: "BarChart2Icon",
		roles: ["owner", "admin"],
		moduleSlug: "benchmarking",
	},
	// "Integrators" (FCR contract-farming) hidden from the menu — the marketplace
	// buyer role is now "Lifter" (see Bird Sale). Restore this block to re-expose
	// the contract-farming feature (routes/views/backend still intact).
	// {
	// 	title: "Integrators",
	// 	route: "integrators",
	// 	icon: "LinkIcon",
	// 	roles: ["owner"],
	// },
	{
		title: "Vet Consultations",
		route: "consultations",
		icon: "PlusCircleIcon",
		roles: ["owner", "admin"],
		moduleSlug: "vet_consult",
	},
	{
		title: "Alert Settings",
		route: "notification-settings",
		icon: "BellIcon",
		roles: ["owner", "admin"],
		moduleSlug: "alert_settings",
	},
	// {
	// 	title: "Poultrac Settings",
	// 	route: "apps-settings-hatchery-list",
	// 	icon: "UsersIcon",
	// 	roles: ["admin", "owner"],
	// },
];

// router.beforeEach((to, from, next) => {
// 	if (to.matched.some((data) => data.meta.permissions)) {
// 		if (record.meta.permissions) {
// 		}
// 	}
// });
